import { render, staticRenderFns } from "./CandidatesLandingPage.vue?vue&type=template&id=915133e0&scoped=true"
import script from "./CandidatesLandingPage.vue?vue&type=script&lang=js"
export * from "./CandidatesLandingPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesLandingPage.vue?vue&type=style&index=0&id=915133e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915133e0",
  null
  
)

export default component.exports